import { useMemo } from 'react';
import dayjs from 'dayjs';

import CountDown from '~/components/CountDown';
import type { OAISchema } from '~/types/openapi';
import { formatAMPMTime } from '~/utils/date';

import { RedTimerIcon } from '~/assets/icons';

dayjs.locale('ko');

type Props = {
  campaign: OAISchema['CampaignFrontListItemResponse'];
  isToday: boolean;
};

export function CampaignInfo({ campaign, isToday }: Props) {
  const { endAtKst, exposureAtKst, catchphrase } = campaign;

  const countdown = useMemo(() => {
    if (!endAtKst) return undefined;
    return dayjs(endAtKst).valueOf() - dayjs().valueOf();
  }, [endAtKst]);

  return (
    <div className="flex flex-col gap-4">
      <p className="text-hint typo-caption100-regular">
        {exposureAtKst && formatAMPMTime(exposureAtKst)}
      </p>
      <p className="truncate text-normal typo-title100-semibold">
        {catchphrase}
      </p>

      {isToday && countdown && dayjs().isBefore(dayjs(endAtKst)) && (
        <p className="flex items-center gap-4 text-error typo-caption100-regular">
          <RedTimerIcon /> 이벤트 종료까지 <CountDown initialTime={countdown} />
        </p>
      )}
    </div>
  );
}
